module.exports = "https://cdn.littlereply.com/tt/resource/earn_guide_step_5@3x.d2c8873e20e9922774a7e44046e47256.png";